import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApi, Customer } from '../../contexts/ApiContext';
import { useAlert } from '../../contexts/AlertContext';
import Button from '../ui/Button';

const CustomerSelection: React.FC = () => {
    const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { customers, loadingCustomers, fetchCustomers } = useApi();
    const { showAlert } = useAlert();

    useEffect(() => {
        fetchCustomers();
    }, [fetchCustomers]);

    const handleCustomerSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const index = parseInt(e.target.value);
        if (customers && index >= 0 && index < customers.length) {
            setSelectedCustomer(customers[index]);
        } else {
            setSelectedCustomer(null);
        }
    };

    const handleContinue = async () => {
        if (!selectedCustomer) {
            showAlert('Please select an organisation to continue.', 'error');
            return;
        }

        setLoading(true);

        try {
            // Set session storage variables
            sessionStorage.setItem('customerCode', selectedCustomer.customer_code);
            sessionStorage.setItem('customerName', selectedCustomer.customer_name);
            sessionStorage.setItem('personType', selectedCustomer.person_type);
            sessionStorage.setItem('peopleId', selectedCustomer.people_id);
            sessionStorage.setItem('companyId', selectedCustomer.company_id);
            sessionStorage.setItem('customerList', JSON.stringify([selectedCustomer]));

            showAlert('Customer selected successfully! Redirecting...', 'success');

            // Navigate to profile page
            setTimeout(() => {
                navigate('/dashboard');
            }, 1000);

        } catch (error) {
            console.error('Error setting customer data:', error);
            showAlert('Error setting customer data. Please try again.', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="form-group">
                <label htmlFor="customerSelect">Available Organisations</label>
                <select
                    id="customerSelect"
                    onChange={handleCustomerSelect}
                    disabled={loadingCustomers}
                    required
                    style={{ fontSize: 'large', width: '100%', boxSizing: 'border-box' }}
                >
                    <option value="">
                        {loadingCustomers ? 'Loading organisations...' : '-- Select an Organisation --'}
                    </option>
                    {customers && customers.map((customer, index) => (
                        <option key={index} value={index}>
                            {customer.customer_name}
                        </option>
                    ))}
                </select>
            </div>

            <Button
                variant="primary"
                loading={loading}
                onClick={handleContinue}
                disabled={!selectedCustomer || loadingCustomers}
            >
                Continue
            </Button>
        </div>
    );
};

export default CustomerSelection;